import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "filter__title"
};
const _hoisted_2 = { class: "filter__list permalink-list__list" };
const _hoisted_3 = ["href"];
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PermalinkList = _resolveComponent("PermalinkList", true);
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`filter filter--${_ctx.taxonomy}`)
    }, [
        (_ctx.title !== null)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terms, (t) => {
                return (_openBlock(), _createElementBlock("li", {
                    key: `term-${t.id}`,
                    class: _normalizeClass(["permalink-list__item", { 'permalink-list_item--selected': t.id === _ctx.selected }])
                }, [
                    _createElementVNode("a", {
                        href: `${_ctx.baseUrl}/${t.slug}`
                    }, _toDisplayString(t.name), 9 /* TEXT, PROPS */, _hoisted_3),
                    (t.children.length > 0 && (_ctx.maxDepth === null || _ctx.depth < _ctx.maxDepth))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!_ctx.fullOpen)
                                ? (_openBlock(), _createElementBlock("small", {
                                    key: 0,
                                    onClick: ($event) => (_ctx.openMap.set(t.id, !_ctx.openMap.get(t.id)))
                                }, _toDisplayString(_ctx.openMap.get(t.id) ? '-' : '+'), 9 /* TEXT, PROPS */, _hoisted_4))
                                : _createCommentVNode("v-if", true),
                            _withDirectives((_openBlock(), _createBlock(_component_PermalinkList, {
                                key: `term-${t.id}`,
                                taxonomy: _ctx.taxonomy,
                                terms: t.children,
                                baseUrl: _ctx.baseUrl,
                                fullOpen: _ctx.fullOpen,
                                selected: _ctx.selected,
                                depth: _ctx.depth + 1,
                                maxDepth: _ctx.maxDepth
                            }, null, 8 /* PROPS */, ["taxonomy", "terms", "baseUrl", "fullOpen", "selected", "depth", "maxDepth"])), [
                                [_vShow, _ctx.fullOpen || _ctx.openMap.get(t.id)]
                            ])
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */));
            }), 128 /* KEYED_FRAGMENT */))
        ])
    ], 2 /* CLASS */));
}
